import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import { isFirstItem } from 'lib/array';

import Tag from './Tag';

const Tags = ({ tags, className }) => (
  <div className={twMerge('flex flex-wrap items-center gap-1', className)}>
    {tags.map(({ name }, index) => (
      <Tag key={name} isFirst={isFirstItem(index)}>
        {name}
      </Tag>
    ))}
  </div>
);

Tags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default Tags;
